import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const ViewLongStringModalOptions: NgbModalOptions = {
    keyboard: true,
    centered: false,
    size: 'xl'
};

@Component({
    templateUrl: './view-long-string.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewLongStringModal {

    @Input() text: string = '';
    @Input() headerTranslationKey: string = 'Dialog.View';
    constructor(private activeModal: NgbActiveModal) { }

    public closeModal() {
        this.activeModal.close();
    }
}
